module.exports = __webpack_public_path__ + "static/landingpage-extraimg1-min2-a75d0ba938dded26ee5715b5a99206db.jpg";